import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import '../styles/AppNavigation.css';

interface AppNavigationProps {
  onNavigate: (section: 'map' | 'weather' | 'ai' | 'favorites' | 'settings' | 'history' | 'hourly' | 'fishing' | 'wind') => void;
  activeSection?: string;
}

export const AppNavigation: React.FC<AppNavigationProps> = ({ onNavigate, activeSection }) => {
  const { t } = useLanguage();

  const navItems = [
    { id: 'weather', icon: '🌤️', label: t.weather || 'Väder' },
    { id: 'hourly', icon: '⏰', label: t.hourlyForecast || 'Timme för timme' },
    { id: 'history', icon: '📜', label: t.weatherHistory || 'Historik' },
    { id: 'fishing', icon: '📊', label: t.fishingForecast || 'Fiske Score' },
    { id: 'wind', icon: '💨', label: t.windSimulator || 'Vindsimulator' },
    { id: 'ai', icon: '🎣', label: 'AI' }
  ];

  return (
    <nav className="app-navigation visible">
      <div className="app-navigation-container">
        {navItems.map((item) => (
          <button
            key={item.id}
            className={`nav-item ${activeSection === item.id ? 'active' : ''}`}
            onClick={() => onNavigate(item.id as any)}
            aria-label={item.label}
          >
            <span className="nav-icon">{item.icon}</span>
            <span className="nav-label">{item.label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
};
